import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { SettingsProvider } from "./context/SettingsContext";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import SiteGate from "./components/SiteGate";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import Shop from "./pages/Shop";
import Category from "./pages/Category";
import ProductPage from "./pages/Product";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import ThankYou from "./pages/ThankYou";
import Wishlist from "./pages/Wishlist";
import Policies from "./pages/Policies";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Customization from "./pages/Customization";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Account from "./pages/Account";
import ClientPreview from "./pages/ClientPreview";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminCategories from "./pages/admin/AdminCategories";
import AdminCustomers from "./pages/admin/AdminCustomers";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminHomepage from "./pages/admin/AdminHomepage";
import AdminAccount from "./pages/admin/AdminAccount";
import AdminLaunch from "./pages/admin/AdminLaunch";
import AdminBackups from "./pages/admin/AdminBackups";

import "@/App.css";

const withLayout = (el) => <Layout>{el}</Layout>;

export default function App() {
  return (
    <SettingsProvider>
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Toaster position="top-center" richColors closeButton />
            <Routes>
              <Route path="/preview" element={<ClientPreview />} />
              <Route element={<SiteGate />}>
                <Route path="/" element={withLayout(<Home />)} />
                <Route path="/shop" element={withLayout(<Shop />)} />
                <Route path="/shop/:categorySlug" element={withLayout(<Category />)} />
                <Route path="/shop/:categorySlug/:subcategorySlug" element={withLayout(<Category />)} />
                <Route path="/category/:slug" element={withLayout(<Category />)} />
                <Route path="/product/:id" element={withLayout(<ProductPage />)} />
                <Route path="/cart" element={withLayout(<Cart />)} />
                <Route path="/checkout" element={withLayout(<Checkout />)} />
                <Route path="/thank-you/:id" element={withLayout(<ThankYou />)} />
                <Route path="/wishlist" element={withLayout(<Wishlist />)} />
                <Route path="/policies" element={withLayout(<Policies />)} />
                <Route path="/contact" element={withLayout(<Contact />)} />
                <Route path="/about" element={withLayout(<About />)} />
                <Route path="/customization" element={withLayout(<Customization />)} />
                <Route path="/login" element={withLayout(<Login />)} />
                <Route path="/register" element={withLayout(<Register />)} />
                <Route
                  path="/account"
                  element={
                    <ProtectedRoute>
                      <Layout>
                        <Account />
                      </Layout>
                    </ProtectedRoute>
                  }
                />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute requireAdmin>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Dashboard />} />
                <Route path="launch" element={<AdminLaunch />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="backups" element={<AdminBackups />} />
                <Route path="orders" element={<AdminOrders />} />
                <Route path="categories" element={<AdminCategories />} />
                <Route path="customers" element={<AdminCustomers />} />
                <Route path="homepage" element={<AdminHomepage />} />
                <Route path="settings" element={<AdminSettings />} />
                <Route path="account" element={<AdminAccount />} />
              </Route>

            </Routes>
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </SettingsProvider>
  );
}
